import { defineMessage, useIntl } from 'react-intl';

const title = defineMessage({
  id: 'slot.joe.label',
  defaultMessage: 'Bonus Club',
});

export const useJoeLink = () => {
  const { formatMessage } = useIntl();

  return {
    href: '/service-hilfe/joe-bonus-club',
    label: formatMessage(title),
  };
};
